export default "__VITE_ASSET__4a37df8e__"